// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_options__jIBWJ > div button {
  font-size: 0.9rem; }

.styles_itemContainer__2MBXC.styles_titleless__hTLVj h4 {
  font-style: italic; }

.styles_itemContainer__2MBXC > div:first-child {
  margin-bottom: unset; }
`, "",{"version":3,"sources":["webpack://./src/modules/entries/components/EntriesFeed/styles.module.scss"],"names":[],"mappings":"AACA;EAEQ,iBAAiB,EAAA;;AAIzB;EAEQ,kBAAkB,EAAA;;AAF1B;EAKQ,oBAAoB,EAAA","sourcesContent":["\n.options {\n    & > div button {\n        font-size: 0.9rem;\n    }\n}\n\n.itemContainer {\n    &.titleless h4 {\n        font-style: italic;\n    }\n    & >div:first-child {\n        margin-bottom: unset;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"options": `styles_options__jIBWJ`,
	"itemContainer": `styles_itemContainer__2MBXC`,
	"titleless": `styles_titleless__hTLVj`
};
export default ___CSS_LOADER_EXPORT___;
